import MachineBoard from "../shared";

export default function MachineTieup() {
  return <MachineBoard mode="tieup" />;
}
